import { Typography, styled, useTheme, Box } from '@mui/material';
import {
  CenterContainer,
  ChangeLanguageWrapper,
  LeftSideBox,
  LoginContainer,
  LoginContainerHeader,
  LoginContainerLogo,
  LoginContainerLogoWrapper,
  RightSideBox,
  RightSideBoxHeading,
  RightSideBoxHeadingContainer,
  RightSideBoxLowerHalf,
  RightSideBoxSubHeading,
  RightSideBoxTrustedBy,
} from './style';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ChangeLanguage from './ChangeLanguage';
import MicrosoftBanner from './MicrosoftBanner';
import CustomersMarquee from './CustomersMarquee';

const Title = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(7)} !important`,
  fontWeight: 600,
  // marginBottom: theme.spacing(4),
  [theme.breakpoints.down('lg')]: {
    fontSize: `${theme.spacing(6)} !important`,
    fontWeight: 600,
  },
  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(5.5)} !important`,
    fontWeight: 500,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: `${theme.spacing(5)} !important`,
    fontWeight: 500,
  },
}));

const Text = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(4),
  fontWeight: 400,
  padding: theme.spacing(8, 0),
  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3.5),
    padding: theme.spacing(4, 0, 3),
  },
}));

const HaveAccount = styled(Typography)(({ theme, isSignup }) => ({
  fontSize: `${theme.spacing(3)} !important`,
  fontWeight: 400,
  marginTop: isSignup ? theme.spacing(6) : theme.spacing(6),
  textAlign: 'center',
  display: 'block',
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.contrastText
      : theme.palette.secondary.neutral_50,
  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(3)} !important`,
  },
}));

const HaveAccountLink = styled(Link)(({ theme }) => ({
  fontSize: `${theme.spacing(3)} !important`,
  display: 'inline-block',
  paddingLeft: theme.spacing(1),
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.secondary_70
      : theme.palette.secondary.main,
  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(3)} !important`,
  },
}));

const HaveAccountButton = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(3)} !important`,
  display: 'inline-block',
  paddingLeft: theme.spacing(1),
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.secondary_70
      : theme.palette.secondary.main,
  cursor: 'pointer',
  textDecoration: 'none',
  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(3)} !important`,
  },
}));

const LayoutAuth = ({
  children,
  title = '',
  text = '',
  showMagicalIcon = true,
  linkHelper = '',
  linkHelperText = '',
  linkHelperMessage = '',
  linkHelperOnClick = null, // Optional function for custom click behavior
  showLanguageChange = true,
  rightSideContent = null, // New prop for content in the right side box (only visible on lg and above)
}) => {
  const theme = useTheme();

  return (
    <CenterContainer>
      <LeftSideBox>
        <LoginContainer isSignup={linkHelper === '/login'}>
          <LoginContainerHeader isSignup={linkHelper === '/login'}>
            {showMagicalIcon ? (
              <LoginContainerLogoWrapper>
                <Link to="/">
                  <LoginContainerLogo
                    className="magicalApi_icon"
                    src={`/static/img/${theme.palette.mode === 'dark' ? 'magicalapi_logo_white.svg' : 'magicalApi-icon.svg'}`}
                  />
                  {/* <LoginContainerLogo
                    className="magicalApi_icon"
                    src={`/static/img/christmas-logo/logo-black.webp`}
                  /> */}
                </Link>
              </LoginContainerLogoWrapper>
            ) : (
              false
            )}
            {title ? <Title>{title}</Title> : null}
          </LoginContainerHeader>
          {text ? <Text>{text}</Text> : null}
          {children}
          {linkHelper || linkHelperOnClick ? (
            <HaveAccount isSignup={linkHelper === '/login'}>
              {linkHelperMessage}{' '}
              {linkHelperOnClick ? (
                <HaveAccountButton onClick={linkHelperOnClick}>
                  {linkHelperText}
                </HaveAccountButton>
              ) : (
                <HaveAccountLink to={linkHelper}>
                  {linkHelperText}
                </HaveAccountLink>
              )}
            </HaveAccount>
          ) : null}

          {showLanguageChange ? (
            <ChangeLanguageWrapper>
              <ChangeLanguage />
            </ChangeLanguageWrapper>
          ) : null}
        </LoginContainer>
      </LeftSideBox>

      {/* Right side box - only visible on lg screens and above */}
      <RightSideBox>
        <RightSideBoxHeadingContainer>
          <RightSideBoxHeading variant="h2">
            Transforming <span>Careers </span>
            and <span>Data</span> Analysis with the power of <span>AI</span>
          </RightSideBoxHeading>
          <RightSideBoxSubHeading>
            Your ultimate tool for Resume Parsing, LinkedIn data and more.
          </RightSideBoxSubHeading>
        </RightSideBoxHeadingContainer>
        <RightSideBoxLowerHalf>
          <MicrosoftBanner />
          <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
            <RightSideBoxTrustedBy>Trusted by</RightSideBoxTrustedBy>
            <CustomersMarquee />
          </Box>
        </RightSideBoxLowerHalf>
      </RightSideBox>
    </CenterContainer>
  );
};

export default LayoutAuth;
